<template>
  <div :class="['station-queue-assembly-thumb-panel', { 'station-queue-thumb-small': isQueueDisplayTypeSmall, 'station-queue-thumb-large': isQueueDisplayTypeLarge, 'selected': selected } ]">
    <div class="panel-container" v-if="!loading && !loadingError">
      <h2 class="title">{{title}}</h2>
      <div class="row no-gutters">
        <div class="col-8">
          <div class="structure-container">
            <div v-for="assOrderItem of assemblyItemList" :key="assOrderItem.id" class="assembly-item" :style="getStylesForAssembly(assOrderItem)">
              <div class="sub-item-arrow" v-if="assOrderItem.level > 0"><i class="fas fa-caret-right" /></div>
              <div class="icon"><i :class="['far', getIconForOrderItem(assOrderItem)]" /></div>
              <div class="details">
                <div class="description">{{assOrderItem.description}}</div>
                <div class="info">
                  <div v-if="assOrderItem.displayInfo">{{assOrderItem.displayInfo}}</div>
                  <div v-if="isOrderItemGeneral(assOrderItem)">{{assOrderItem.stock.barcode}}</div>
                  <div v-if="assOrderItem.showAvailable">{{assOrderItem.availableCount}} Available</div>                  
                </div>
              </div>
              <div class="status">
                <i :class="{'far': true, 'fa-circle': !assOrderItem.scanningCompleted, 'fa-check-circle': assOrderItem.scanningCompleted, 'result-fg-success': assOrderItem.scanningCompleted}" /><br />
                <span :class="{'counts': true, 'result-fg-success': assOrderItem.scanningCompleted}">{{assOrderItem.scannedCount}} / {{assOrderItem.requiredCount}} {{assOrderItem.uomSuffix}}</span>
              </div>
              <div class="menu">
                <ActionDropMenu>
                  <DropdownMenuItem icon="fa-clipboard-list-check" @click="viewSubItemDetailClicked(assOrderItem)" v-if="canDisplaySubItemDetails(assOrderItem)">View Details</DropdownMenuItem>
                  <DropdownMenuItem icon="fa-scanner" @click="completeSubItemClicked(assOrderItem)" v-if="canCompleteOrderItem(assOrderItem)">Flag Completed</DropdownMenuItem>
                </ActionDropMenu>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="thumbnail-container">
            <div v-if="hasPreviewDisplayData" v-html="panel.orderItem.svgDisplayData" class="thumbnail" @click.prevent="previewClicked" />
            <h2 v-if="!hasPreviewDisplayData" class="text-center text-muted font-italic">
              No preview available
            </h2>
          </div>
        </div>
      </div>
      <div class="info-bar">
        <div class="row no-gutters">
          <div class="col-8">
            <div class="row no-gutters">
              <div class="col-5 stock">{{panel.orderItem.stock.name}}</div>
              <div class="col-3 stock">{{panel.orderItem.glassHeight}} x {{panel.orderItem.glassWidth}}</div>
              <div class="col-4 panel-location-info">{{panelStationName}}</div>
            </div>
            <div class="row no-gutters">
              <div class="col-5"><i class="fal fa-scanner fa-fw mr-2"></i> {{panel.barcode}}</div>
              <div class="col-3">{{panel.order.sequenceNumber}}</div>
              <div class="col-4"><i class="fal fa-clock fa-fw mr-2"></i> {{panelStationDuration}}</div>
            </div>
          </div>
          <div class="col-4 station-queue-thumb-panel-options text-right">
            <button class="btn btn-success" @click.prevent="printLabelClicked" v-if="displayPrintLabel">
              <i class="fal fa-print"></i> {{printLabelButtonTitle}}
            </button>
            <button class="btn btn-default ml-2" @click.prevent="panelClicked">
              <i class="fal fa-info-circle"></i> Info
            </button>
            <button class="btn btn-danger ml-2" @click.prevent="removePanelClicked" v-if="canRemovePanel">
              <i class="fal fa-times"></i> Remove
            </button>
          </div>
        </div>
      </div>
    </div>
    <LoadingPanel :loading="loading" :loadingError="loadingError" />
  </div>
</template>

<style lang="scss">
.station-queue-assembly-thumb-panel {
  width: 50%;
  margin: 0;
  font-size: 14px;
  color: #A0A0A0;
}
.station-queue-assembly-thumb-panel .title {
  margin-top: 2px;
}
.station-queue-assembly-thumb-panel.selected .title {
  color: #4da9ff;
}
.station-queue-assembly-thumb-panel.station-queue-thumb-small {
  width: 50%;
}
.station-queue-assembly-thumb-panel.station-queue-thumb-large {
  width: 100%;
}
.station-queue-assembly-thumb-panel .panel-container {
  margin: 0.25rem;
  padding: 6px;
  background-color: #333333;
  border-radius: $layout-minor-border-radius;
}
.station-queue-assembly-thumb-panel.selected .panel-container {
  background-color: #404040;
}
.station-queue-assembly-thumb-panel .structure-container {
  border: 1px solid #1e1e1e;
  background-color: #272727;
  margin: 0.25rem;
  height: 200px;
  padding: 0.5rem;
  overflow-y: auto;
}
.station-queue-assembly-thumb-panel.station-queue-thumb-large .structure-container {
  height: 400px;
}
.station-queue-assembly-thumb-panel .thumbnail-container {
  border: 1px solid #1e1e1e;
  background-color: #272727;
  margin: 0.25rem;
  height: 200px;
}
.station-queue-assembly-thumb-panel.station-queue-thumb-large .thumbnail-container {
  height: 400px;
}
.station-queue-assembly-thumb-panel .thumbnail {
  max-width: 100%;
  max-height: 100%;
}
.station-queue-assembly-thumb-panel .thumbnail:hover {
  outline: 2px solid #4da9ff;
}
.station-queue-assembly-thumb-panel .thumbnail svg {
  width: 100%;
  height: 200px !important;
  max-width: 100%;
  max-height: 100%;
}
.station-queue-assembly-thumb-panel.station-queue-thumb-large .thumbnail svg {
  height: 400px !important;
}

.station-queue-assembly-thumb-panel .thumbnail svg path.svg-dimension-line,
.station-queue-assembly-thumb-panel .thumbnail svg path.svg-dimension-arrow,
.station-queue-assembly-thumb-panel .thumbnail svg path.svg-edgework-legend-box {
  fill: #FFFFFF !important;
  stroke: #FFFFFF !important;
}
.station-queue-assembly-thumb-panel .thumbnail svg path.svg-summary-header-box {
  fill: #404040 !important;
}
.station-queue-assembly-thumb-panel .thumbnail svg text {
  fill: #FFFFFF !important;
}
.station-queue-assembly-thumb-panel .thumbnail svg text.svg-dimension-text {
  stroke: #272727 !important;
}

.station-queue-assembly-thumb-panel > div {
  line-height: 1.2rem;
  vertical-align: middle;
}
.station-queue-assembly-thumb-panel .panel-location-info {
  color: #4da9ff;
  font-weight: 600;
}
.station-queue-assembly-thumb-panel .stock {
  color: #4da9ff;
  font-weight: 600;
}
.station-queue-assembly-thumb-panel .station {
  font-weight: bold;
  color: #4fcc3b !important;
}
.station-queue-assembly-thumb-panel .row {
  padding: 3px;
}
.station-queue-assembly-thumb-panel .station-queue-thumb-panel-options {
  position: relative;
  font-size: 0.9rem;
}

.station-queue-assembly-thumb-panel .station-queue-thumb-panel-options .btn {
  width: 52px;
  height: 46px;
  padding: 0;
  font-size: 11px;
  text-transform: uppercase;
}
.station-queue-assembly-thumb-panel .station-queue-thumb-panel-options .btn > i {
  font-size: 1.2rem;
  display: block;
  padding: 4px 0px 5px 0px;
}

.station-queue-assembly-thumb-panel .assembly-item {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin-bottom: 1.1rem;
}
.station-queue-assembly-thumb-panel .assembly-item .sub-item-arrow {
  width: 20px;
  font-size: 1.4rem;
  height: 44px;
  line-height: 44px;
  vertical-align: middle;
}
.station-queue-assembly-thumb-panel .assembly-item .icon {
  width: 44px;
  height: 44px;
  font-size: 1.1rem;
  line-height: 44px;
  vertical-align: middle;
  background-color: #404040;
  color: #ffffff;
  text-align: center;
  border-radius: $control-border-radius;
}
.station-queue-assembly-thumb-panel .assembly-item .details {
  flex: 1;
  padding-left: 1rem;
}
.station-queue-assembly-thumb-panel .assembly-item .description {
  font-size: 0.9rem;
  color: #4da9ff;
  font-weight: 600;
}
.station-queue-assembly-thumb-panel .assembly-item .status {
  width: 75px;
  padding-top: 4px;
  text-align: center; 
}
.station-queue-assembly-thumb-panel .assembly-item .menu {
  width: 50px;
  text-align: right;
}
.station-queue-assembly-thumb-panel .assembly-item .status > i {
  font-size: 1.2rem;
}
.station-queue-assembly-thumb-panel .assembly-item .status > .counts {
  font-size: 0.8rem;
  font-weight: 600;
}

</style>

<script>
import moment from 'moment'
import orderItemMixin from '@/modules/orders/mixins/orderItemMixin'

import AssemblySubItemDialog from '@/apps/glass-production-station/src/views/assemblySubItemDialog'

import { InventoryStockTypes, ProductionStationQueueDisplayTypes, InventoryStockTypeLookup, ProductionPanelStatusTypes, ProductionPanelStageTaskStatusTypes, AssemblyScannedItemTypes, UOMTypeUnitsSafeLookup } from '@/store/types'

export default {
  name: 'QueueAssemblyThumbItem',
  mixins: [orderItemMixin],
  props: {
    panel: Object,
    productionStationId: Number,
    productionStageId: Number,
    removeEnabled: {
      type: Boolean,
      default: true
    },
    selected: Boolean,
    highlightColour: String,
    queueDisplayType: String
  },
  data() {
    return {
      loading: true,
      loadingError: '',
      orderData: {},
      orderPanels: [],
      assemblyData: {},
      assemblyItemList: [],
      panelTimeInQueue: 0
    }
  },
  created() {
    this.InventoryStockTypes = InventoryStockTypes
  },
  mounted() {
    this.updatePanelTimer()
    this.$options.queuePanelTimer = setInterval(this.updatePanelTimer, 15000)

    this.requestData()
  },
  beforeDestroy () {
    clearInterval(this.$options.queuePanelTimer)
  },
  computed: {
    title() {
      if(this.panel && this.panel.orderItem.stock)
        return `Assembly - ${this.panel.orderItem.stock.name}`
      return 'Assembly'
    },
    panelStationDuration() {
      if(!this.panel || !this.panel.currentStationStartDate)
        return ''

      if(this.panelTimeInQueue <= 60)
        return `${this.panelTimeInQueue} mins`      
      if(this.panelTimeInQueue >= 24*60)
        return '24+ hrs'

      let hours = Math.floor(this.panelTimeInQueue / 60)
      return `${hours} hrs`
    },
    panelStationName() {
      if(!this.panel || !this.panel.currentProductionStation)
        return ''

      return `At ${this.panel.currentProductionStation.name}`
    },
    canRemovePanel() {
      if(!this.panel)
        return false
        
      // Can only remove if the panel is at the station currently displaying it
      return this.removeEnabled && this.panel.currentProductionStationId == this.productionStationId
    },
    canDisplayPreview() {
      if(!this.panel)
        return false
        
      return true
    },
    hasPreviewDisplayData() {
      if(this.panel && this.panel.orderItem && this.panel.orderItem.svgDisplayData)
        return true
      return false
    },
    accountHasOrderEditor() {
      // If the account has no order editor feature available, don't display thumbnails at all
      return this.accountHasProductFeature(this.AccountProductFeatureTypes.orderEditor)
    },
    panelIsOnHold() {
      if(this.panel && this.panel.order && this.panel.order.isOnHold)
        return true
      return false
    },
    isQueueDisplayTypeSmall() {
      return this.queueDisplayType == ProductionStationQueueDisplayTypes.smallThumbnail
    },
    isQueueDisplayTypeLarge() {
      return this.queueDisplayType == ProductionStationQueueDisplayTypes.largeThumbnail
    },
    displayPrintLabel() {
      return true
    },
    printLabelButtonTitle() {
      if(this.panel && this.panel.isPanelLabelPrinted)
        return 'Reprint'
      return 'Print'
    },
  },
  methods: {
    requestData() {
      this.loadingError = ''

      Promise.all([
        this.$apiService.ordersService.getOrder(this.panel.orderId),
        this.$apiService.ordersService.getOrderProductionPanelList(this.panel.orderId),
        this.$apiService.productionService.getProductionPanel(this.panel.id)
      ])
      .then(results => {
        this.orderData = results[0].data
        this.orderPanels = results[1].data
        this.assemblyData = results[2].data

        // Calculate assembly structure in orderItems for this panel & calculate where all other panels are at
        this.buildAssemblyStructure()
      })
      .catch(err => {
        this.loadingError = 'Error loading assembly data'
      })
      .finally(() => {
        this.loading = false
      })
    },
    reloadData() {
      this.requestData()
    },
    updatePanelTimer() {
      if(this.panel.currentStationStartDate == null)
        this.panelTimeInQueue = 0
      else
        this.panelTimeInQueue = Math.floor(moment.duration(moment().diff(this.panel.currentStationStartDate)).asMinutes())
    },
    panelClicked(ev) {
      this.$emit('panelClicked', ev)
    },
    previewClicked(ev) {
      ev.stopPropagation()
      ev.preventDefault()
      this.$emit('previewClicked', ev)
    },
    removePanelClicked(ev) {
      ev.stopPropagation()
      ev.preventDefault()
      this.$emit('removePanel')
    },
    printLabelClicked(ev) {
      if(this.panel.isPanelLabelPrinted)
        this.$emit('reprintLabelClick', this.panel)
      else
        this.$emit('printLabelClick', this.panel)

      ev.stopPropagation()
      ev.preventDefault()
    },
    viewSubItemDetailClicked(orderItem) {
      this.displayModal(AssemblySubItemDialog, { 
        productionStageId: this.productionStageId,
        productionStationId: this.productionStationId,
        order: this.orderData,
        orderItem: orderItem,
        productionPanel: this.assemblyData,
        matchingProductionItemList: orderItem.matchingPanelList,
        productionAssemblyScannedItems: orderItem.productionAssemblyScannedItems
      })
      .then((result) => {
        // Reload after closed
        this.reloadData()
      })
    },
    completeSubItemClicked(orderItem) {
      this.$emit('scanCompleteItem', orderItem.stock.barcode)
    },
    isOrderItemGeneral(orderItem) {
      return orderItem.stockType == InventoryStockTypes.general
    },
    canDisplaySubItemDetails(orderItem) {
      // Always display if something scanned item
      if(orderItem.scannedCount > 0)
        return true

      // Only display if glass / assembly
      return orderItem.stockType == InventoryStockTypes.glass || orderItem.stockType == InventoryStockTypes.assembly
    },
    canCompleteOrderItem(orderItem) {
      if(orderItem.stockType != InventoryStockTypes.general)
        return false

      return !orderItem.scanningCompleted
    },
    buildAssemblyStructure() {
      this.assemblyItemList = []
      
      this.addAssemblyOrderItems(this.panel.orderItem.id)
    },
    addAssemblyOrderItems(parentOrderItemId, level = 0) {
      let assemblyData = _.get(this.assemblyData, 'stationData.assemblyData') || {}

      var availablePanels = this.orderPanels.filter(panel => {
        if(panel.status != ProductionPanelStatusTypes.pending && panel.status != ProductionPanelStatusTypes.production)
          return false

        // Sort panel stage tasks
        panel.productionPanelStageTasks.sort((task1, task2) => task1.taskOrder - task2.taskOrder)

        // Must be pending & not already in production
        let currentStage = panel.productionPanelStageTasks.findLast(stageTask => {
          return stageTask.status == ProductionPanelStageTaskStatusTypes.pending
        })

        // Needs to be up to this stage
        return (currentStage && currentStage.productionStageId == this.productionStageId)
      })

      this.orderData.orderItems.forEach((orderItem, index) => {
        if(orderItem.parentOrderItemId == parentOrderItemId) {

          // Ignore services
          if(orderItem.stockType == InventoryStockTypes.glassService)
            return

          // Ignore general items that do not have production completable flag
          if(orderItem.stockType == InventoryStockTypes.general && !orderItem.stock.isProductionCompletable)
            return

          let outAssItem = _.cloneDeep(orderItem)

          // Find all panels for this order item
          outAssItem.panelList = this.orderPanels.filter(panel => panel.orderItemId == orderItem.id)
          outAssItem.level = level

          // Get scanned items into this stage
          outAssItem.productionAssemblyScannedItems = this.assemblyData.productionAssemblyScannedItems.filter(scannedItem => scannedItem.linkedOrderItemId == orderItem.id)

          outAssItem.scannedPanels = _.compact(this.assemblyData.productionAssemblyScannedItems.map(scannedItem => {
            if(scannedItem.scannedType == AssemblyScannedItemTypes.productionPanel && scannedItem.scannedQuantity > 0)
              return this.orderPanels.find(panel => panel.id == scannedItem.productionPanelId)

            return null
          }))

          // Calculate details
          outAssItem.requiredCount = 1
          outAssItem.uomSuffix = 'Ea'

          if(outAssItem.stockType == InventoryStockTypes.general) {
            outAssItem.requiredCount = outAssItem.units
            outAssItem.uomSuffix = this.formatLookupName(outAssItem.stock.uomType, UOMTypeUnitsSafeLookup)
          }

          outAssItem.availableCount = 0
          outAssItem.scannedCount = outAssItem.productionAssemblyScannedItems.reduce((curValue, scannedItem) => {
            return curValue + scannedItem.scannedQuantity
          }, 0)

          // Calculate available panels based on OrderItem matrix in assembly data
          if(_.isArray(assemblyData.orderItemList)) {
            let matchingPanels = availablePanels.filter(panel => {

              // Check if the panel is in the matrix of available order items
              let isPanelLinked = assemblyData.orderItemList.some(matrixOrderItem => {
                if(matrixOrderItem.id == orderItem.id && matrixOrderItem.otherOrderItemIdList) {
                  return matrixOrderItem.otherOrderItemIdList.includes(panel.orderItemId)
                }
              })

              return isPanelLinked
            })

            outAssItem.matchingPanelList = matchingPanels
            outAssItem.availableCount = matchingPanels.length
          }

          outAssItem.showAvailable = false
          outAssItem.scanningCompleted = outAssItem.scannedCount == outAssItem.requiredCount

          if(!outAssItem.scanningCompleted && (orderItem.stockType == InventoryStockTypes.assembly || orderItem.stockType == InventoryStockTypes.glass))
            outAssItem.showAvailable = true

          outAssItem.displayInfo = this.formatLookupName(outAssItem.stockType, InventoryStockTypeLookup)

          if(outAssItem.stockType == InventoryStockTypes.glass) {
            outAssItem.displayInfo = `${outAssItem.glassHeight} x ${outAssItem.glassWidth}`
            if(outAssItem.generatedDescription && outAssItem.generatedDescription != '') {
              outAssItem.displayInfo += ` - ${outAssItem.generatedDescription}`
            }
            if(outAssItem.pricingDescription && outAssItem.pricingDescription != '-') {
              outAssItem.displayInfo += ` - ${outAssItem.pricingDescription}`
            }
          }

          this.assemblyItemList.push(outAssItem)

          // Add child order items
          // Don't traverse down child assemblies, they have need to be processed seperately
          if(orderItem.stockType != InventoryStockTypes.assembly) {
            this.addAssemblyOrderItems(orderItem.id, level+1)
          }
        }
      })
    },
    getStylesForAssembly(assemblyOrderItem) {
      return {
        'padding-left': `${assemblyOrderItem.level * 15}px`
      }
    }
  }
}
</script>